// extracted by mini-css-extract-plugin
export default {"title":"onboarding_title__DjsnZ","description":"onboarding_description__CQEL7","copy":"onboarding_copy__4KLQ5"};